import React, { useContext } from "react";
import { Pie, PieChart, Tooltip } from "recharts";
import { ChartContext } from "../Dashboard/Dashboard";

const PChart = () => {
  const data = useContext(ChartContext);
  return (
    <div>
      <h3>Investment Vs. Revenue</h3>
      <PieChart width={450} height={400}>
        <Pie
          dataKey="investment"
          isAnimationActive={false}
          data={data}
          cx="50%"
          cy="50%"
          outerRadius={80}
          fill="#badc58"
        />
        <Pie
          dataKey="revenue"
          isAnimationActive={false}
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={80}
          fill=" #6ab04c"
          label
        />

        <Tooltip />
      </PieChart>
    </div>
  );
};

export default PChart;
